/**
 * Put `el` at the top of its scroll box (`viewport`), then tell listeners (the rail's "pinned to newest" tracking) the
 * position changed. Sets `scrollTop` rather than calling `scrollIntoView`, which would also scroll the page.
 */
export function scrollViewportTo(viewport: HTMLElement, el: Element, gap = 8): void {
  const top = el.getBoundingClientRect().top - viewport.getBoundingClientRect().top + viewport.scrollTop - gap
  viewport.scrollTop = Math.max(0, top)
  viewport.dispatchEvent(new Event('scroll', { bubbles: true }))
}
